import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import { map } from './map';
import { sliders } from './sliders';
import _ from 'lodash';

let iso;
const postsPerPage = 12;

const showNextItems = (pagination) => {
	const hiddenItems = document.querySelectorAll('.hidden-item');

	if(hiddenItems.length) {
		hiddenItems.forEach((item, index) => {
			if (index < pagination) {
				item.classList.remove('hidden-item');
			}
		});

		iso.layout();
	}
}

const updateFilterCounts = () => {
	var itemElems = iso.getFilteredItemElements()

	let cards = document.querySelectorAll('.live-feed__item');

	cards.forEach((card) => {
		if(card.classList.contains('hidden-item'))
		{
			card.classList.remove('hidden-item');
		}
	})

	itemElems.forEach((item, index) => {
		if (index >= postsPerPage) {
			item.classList.add('hidden-item');
		}
	});

	iso.layout();
}

export function setup_masonary()
{
	var grid = document.querySelector('.live-feed__inner');

	if(grid)
	{
		iso = new Isotope( grid, {
			itemSelector: '.live-feed__item',
			percentPosition: true,
			getSortData: {				
				date: '[data-date]',
				tag: '[data-sort]',
			},
			sortBy: ['date','tag'],
			sortAscending: {				
				date: false,
				tag: false,
			},
			hiddenStyle: {
				opacity: 0,
			},
			visibleStyle: {
				opacity: 1,
			},
			transitionDuration: 0,
			layoutMode: 'fitRows',
			fitRows: {
				gutter: 12,
			},
			initLayout: true,
			resize: true,
		});

		
		iso.layout();
		
	}

}

function handleFeedHover(e)
{
	const target = e.target;
	const type = target.getAttribute('data-type');
	const slug = target.getAttribute('data-slug');

	let posts = document.querySelectorAll('.live-feed__item');

	posts.forEach(post => {
		let post_type = post.getAttribute(`data-${type}`);

		if(post_type !== null)
		{
			if(post_type.toLowerCase() !== slug)
			{
				post.classList.add('inactive');
			} else {
				post.classList.remove('inactive');
			}
		} else {
			post.classList.remove('inactive');
		}
	});
}

function handleChildLeave(e)
{
	let feed = document.querySelector('.live-feed');
	let posts = document.querySelectorAll('.live-feed__item');

	posts.forEach(post => {
		post.classList.remove('inactive');
	});

	feed.setAttribute('data-project', '');

	updateFilterCounts();
}


function getActiveFilters()
{
	const activeFilters = document.querySelectorAll('.filter-item.active, .filter-item.open');
	const filterList = [];

	if(activeFilters)
	{
		activeFilters.forEach(activeFilter => {
			const type = activeFilter.getAttribute('data-type');
			const slug = activeFilter.getAttribute('data-slug');

			filterList.push({
				type,
				slug,
			})
		});
	}

	return filterList;
}

function filterPosts()
{
	let filterTerm = '*';
	const activeFilters = getActiveFilters();

	if(activeFilters && activeFilters.length)
	{
		filterTerm = '';

		activeFilters.forEach(({ type, slug }) => {
			filterTerm += `[data-${type}="${slug}"]`;
		})
	}

	let activeSortby = filterTerm.includes('news') ? 'date' : 'tag';

	iso.arrange({ filter: filterTerm , sortBy: [activeSortby], sortAscending: false });
	iso.layout();
	updateFilterCounts();
}

function unfilterPosts()
{
	let filterTerm = '*';

	iso.arrange({ filter: filterTerm , sortBy: ['date','tag'], sortAscending: {				
		date: false,
		tag: false,
	} });
	iso.layout();
	updateFilterCounts();
}

function handleParentLeave(e)
{
	var feed = document.querySelector('.live-feed');
	let posts = document.querySelectorAll('.live-feed__item');
	let childFilters = document.querySelectorAll('.child-filter');

	posts.forEach(post => {
		post.classList.remove('inactive');
	});

	childFilters.forEach(filter => {
		filter.classList.remove('active');
	});

	e.target.classList.add('active');

	feed.setAttribute('data-hub', '');

	unfilterPosts();
}

function handleFilterClick(e, filter = true)
{
	e.stopPropagation();

	const target = e.target;
	//console.log('handleFilterClick--', target.getAttribute('src'))
	if(target.classList.contains('child-filter') && target.classList.contains('active'))
	{
		
		e.preventDefault();
		return true;
	}

	const siblings = document.querySelectorAll('.child-filter');

	siblings.forEach((sibling) => {
		sibling.classList.remove('active');
	})

	target.classList.add('active');

	if(filter) {
		filterPosts();
	}
}

export function feedFiltering()
{
	let feedFilters = document.querySelectorAll('.feed-filter');
	let childFilters = document.querySelectorAll('.child-filter');

	feedFilters.forEach(filter => {
		const hasChildren = filter.querySelector('.home-nav__sub-menu');

		filter.addEventListener('click', (e) => {
			e.stopPropagation();

			if(!hasChildren || hasChildren === null) {
				handleFilterClick(e);
			} else if(filter.classList.contains('open')) {
				handleParentLeave(e);
			} else {
				handleParentLeave(e);
			}
		});
	});

	childFilters.forEach(filter => {
		filter.addEventListener('mouseenter', handleFeedHover);
		filter.addEventListener('mouseleave', handleChildLeave);

		filter.addEventListener('click', handleFilterClick);

		let innerLink = filter.querySelector('a');

		innerLink.addEventListener('click', (e) => {
			e.stopPropagation();
		});
	});
}


export function loadMore()
{
	const throttleLoadMore = _.throttle(() => {
		const threshhold = document.body.offsetHeight * 0.875;

		if ((window.innerHeight + window.scrollY) >= threshhold) {
			showNextItems(postsPerPage);
		}
	}, 200);

	window.addEventListener('scroll', throttleLoadMore);
}

function updateBlogFilter()
{
	const activeFilters = getActiveFilters();

	let container = document.querySelector('.res-container');
	let body = document.body;
	let cards = document.querySelectorAll('.card');

	let relatedPosts = container.getAttribute('data-id');
	let currentId = container.getAttribute('data-pageid');
	relatedPosts = relatedPosts.replace(/,\s*$/, '');

	let post_hub = '&hub=';
	let post_term = '&category=';
	let related_ids = `&id=${relatedPosts}`;
	let current_ids = `&page_id=${currentId}`;

	// Already running
	if(body.classList.contains('loading'))
	{
		return;
	}

	body.classList.add('loading');

	cards.forEach((card) => {
		card.classList.remove('loading-in');
	})

	if(activeFilters && activeFilters.length)
	{
		activeFilters.forEach(({ type, slug }) => {
			if(type === 'hub_category')
			{
				post_hub += `${slug},`;
			}
			else
			{
				post_term += `${slug},`
			}
		})

		//Remove the last comma
		post_hub = post_hub.replace(/,\s*$/, '');
		post_term = post_term.replace(/,\s*$/, '');
	}

	let action = '?action=run_search';

	fetch(`${Ajax.url}${action}${post_hub}${post_term}${related_ids}${current_ids}`, {
		method: 'post',
		headers: {
			'Content-Type': 'x-www-form-urlencoded',
		},
	})
	.then((response) => {
		body.classList.add('replacing-posts');

		if (response.status !== 200) {
			console.log('error', response.status);
			return;
		}

		return response.json();
	}).then((data) => {
		setTimeout( () => {
			container.innerHTML= data.posts;

			sliders();
			map();
		}, 50);
	})
	.catch((err) => {
		console.log('Fetch Error :-S', err);
	}).finally(() => {
		setTimeout( () => {
			body.classList.remove('loading', 'replacing-posts');
		}, 200);
	});
}


export function singleProjectFiltering()
{
	let filters = document.querySelectorAll('.post-filter');

	filters.forEach((filter) =>
	{
		filter.addEventListener('click', () =>
		{
			let parent = filter.parentNode.parentNode;
			let siblings = parent.querySelectorAll('.active');

			if(filter.classList.contains('active'))
			{
				filter.classList.remove('active');
			}
			else
			{
				siblings.forEach((sibling) => {
					sibling.classList.remove('active');
				})

				filter.classList.toggle('active');
			}

			updateBlogFilter();
		})
	})
}

$( window ).on('load', function() {
	// Handler for .load() called.
	//console.log('aaaaaaaaaaaaaaa..........');
	updateFilterCounts();
});


// WEBPACK FOOTER //
// ./scripts/modules/live-feed.js